import { useSidebar } from '@/components/ui/sidebar-context'
import { useEffect, useEffectEvent, useRef, useState } from 'react'

function restoreDesktopSidebarState({ isMobile, open, previousSidebarOpenRef, setOpen }) {
  if (isMobile || previousSidebarOpenRef.current === null) {
    return
  }

  if (open !== previousSidebarOpenRef.current) {
    setOpen(previousSidebarOpenRef.current)
  }

  previousSidebarOpenRef.current = null
}

export default function useWebsiteEditorFocusMode() {
  const { isMobile, open, setOpen, setOpenMobile } = useSidebar()
  const [isFocusMode, setIsFocusMode] = useState(false)
  const previousSidebarOpenRef = useRef(null)

  const restoreDesktopSidebarOnUnmount = useEffectEvent(() =>
    restoreDesktopSidebarState({ isMobile, open, previousSidebarOpenRef, setOpen })
  )

  const restoreDesktopSidebar = () => {
    restoreDesktopSidebarState({ isMobile, open, previousSidebarOpenRef, setOpen })
  }

  const enterFocusMode = () => {
    if (!isMobile) {
      previousSidebarOpenRef.current = open

      if (open) {
        setOpen(false)
      }
    } else {
      setOpenMobile(false)
    }

    setIsFocusMode(true)
  }

  const exitFocusMode = () => {
    setIsFocusMode(false)
    restoreDesktopSidebar()
  }

  useEffect(() => {
    return () => restoreDesktopSidebarOnUnmount()
  }, [])

  return {
    enterFocusMode,
    exitFocusMode,
    isFocusMode,
    toggleFocusMode: isFocusMode ? exitFocusMode : enterFocusMode,
  }
}
